module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0561e0b45ae23b46a901b25549db50cc.png";